import React from "react";
import { Thermometer, Drop, Sun, Wind, CloudRain, MapPin } from "@phosphor-icons/react";

const stat = (label, value, unit, Icon) => ({ label, value, unit, Icon });

export default function ClimatePanel({ climate, locationLabel, loading, error, compact }) {
  if (!climate && !loading && !error) return null;

  const stats = climate
    ? [
        stat("Temperature", climate.temperature_c, "°C", Thermometer),
        stat("Feels like", climate.apparent_temperature_c, "°C", Sun),
        stat("Humidity", climate.humidity_pct, "%", Drop),
        stat("UV index", climate.uv_index, "", Sun),
        stat("Wind", climate.wind_kph, "km/h", Wind),
        stat("Precip", climate.precipitation_mm, "mm", CloudRain),
      ]
    : [];

  return (
    <div className={`glass rounded-2xl ${compact ? "p-4" : "p-5"} relative overflow-hidden`} data-testid="climate-panel">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2 text-forest">
          <MapPin size={16} weight="duotone" />
          <span className="font-mono-data text-ink/80" data-testid="climate-location">
            {loading ? "locating…" : locationLabel || (climate ? "Your location" : "No climate data")}
          </span>
        </div>
        {climate?.weather_description && (
          <span className="tag" data-testid="climate-weather">{climate.weather_description}</span>
        )}
      </div>
      {error && <div className="text-sm text-terra" data-testid="climate-error">{error}</div>}
      {loading && !climate && <div className="font-mono-data text-mute animate-pulse-soft">fetching live climate…</div>}
      {climate && (
        <div className="grid grid-cols-3 gap-3" data-testid="climate-stats">
          {stats.map((s) => (
            <div key={s.label} className="bg-white/60 border border-sand-200 rounded-xl p-3">
              <div className="flex items-center gap-1 text-mute"><s.Icon size={12} weight="duotone" /><span className="font-mono-data">{s.label}</span></div>
              <div className="mt-1 font-display text-2xl text-ink leading-none">
                {s.value !== null && s.value !== undefined ? s.value : "—"}
                <span className="text-sm text-mute font-sans ml-1">{s.unit}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
